import { useTranslation } from 'react-i18next';

import { Button } from '../../../components/ui/button';
import { LoadingButton } from '../../../components/ui/loadingButton';
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from '../../../components/ui/drawer';
import { useCancelOrder } from '../services/cancelOrder';

type CancelOrderDrawerProps = {
  orderId: number;
  open: boolean;
  setOpen: (open: boolean) => void;
};

/** Подтверждение отмены заказа — той же формы, что и выход из аккаунта. */
export const CancelOrderDrawer = ({
  orderId,
  open,
  setOpen,
}: CancelOrderDrawerProps) => {
  const { t } = useTranslation();
  const { cancelOrder, isPending } = useCancelOrder();

  const handleConfirm = async () => {
    try {
      await cancelOrder(orderId);
      setOpen(false);
    } catch {
      // Причину показал useCancelOrder; шторку оставляем — пусть решает сам.
    }
  };

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerContent className="bg-fill-background px-4 pb-safe-bottom">
        <div className="flex flex-col items-center pt-2 text-center">
          <DrawerTitle className="text-display-md max-w-[280px]">
            {t('cancel-order-confirm')}
          </DrawerTitle>
        </div>
        <div className="flex flex-row space-x-2 py-4">
          <LoadingButton
            loading={isPending}
            className="h-12 flex-1 rounded-xl bg-fill-danger shadow-none"
            onClick={handleConfirm}
          >
            <p className="text-display-sm text-text-white">
              {t('cancel-order')}
            </p>
          </LoadingButton>
          <Button
            disabled={isPending}
            className="h-12 flex-1 rounded-xl bg-button-secondary shadow-none"
            onClick={() => setOpen(false)}
          >
            <p className="text-display-sm text-text-primary">{t('back')}</p>
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
